var exports = {
  "SA": "VoiceConnectionStatus.module__voiceConnectionContainer___YmpnbU",
  "jf": "VoiceConnectionStatus.module__statusRow___YmpnbU",
  "Tm": "VoiceConnectionStatus.module__channelAvatarStack___YmpnbU",
  "kR": "VoiceConnectionStatus.module__signalIcon___YmpnbU",
  "rI": "VoiceConnectionStatus.module__statusButton___YmpnbU",
  "QQ": "VoiceConnectionStatus.module__statusConnected___YmpnbU",
  "Rg": "VoiceConnectionStatus.module__statusConnecting___YmpnbU",
  "iA": "VoiceConnectionStatus.module__statusDisconnected___YmpnbU",
  "ne": "VoiceConnectionStatus.module__controls___YmpnbU",
  "uH": "VoiceConnectionStatus.module__controlButton___YmpnbU",
  "wH": "VoiceConnectionStatus.module__selected___YmpnbU",
  "Kk": "VoiceConnectionStatus.module__icon___YmpnbU",
  "Hd": "VoiceConnectionStatus.module__connectionInfo___YmpnbU",
  "J3": "VoiceConnectionStatus.module__channelSourceRow___YmpnbU",
  "Dt": "VoiceConnectionStatus.module__channelSourceLink___YmpnbU",
  "_R": "VoiceConnectionStatus.module__channelSourceText___YmpnbU",
  "wl": "VoiceConnectionStatus.module__channelSourceChannel___YmpnbU",
  "EF": "VoiceConnectionStatus.module__channelSourceSeparator___YmpnbU",
  "_u": "VoiceConnectionStatus.module__channelSourceGuild___YmpnbU",
  "wt": "VoiceConnectionStatus.module__connectionIdRow___YmpnbU",
  "TR": "VoiceConnectionStatus.module__connectionIdValue___YmpnbU",
  "Gh": "VoiceConnectionStatus.module__connectionIdValueText___YmpnbU",
  "Hz": "VoiceConnectionStatus.module__connectionIdIcon___YmpnbU",
  "EU": "VoiceConnectionStatus.module__mediaSection___YmpnbU",
  "LA": "VoiceConnectionStatus.module__mediaButton___YmpnbU",
  "A1": "VoiceConnectionStatus.module__cameraActive___YmpnbU",
  "Cb": "VoiceConnectionStatus.module__screenShareActive___YmpnbU",
  "i7": "VoiceConnectionStatus.module__soundboardActive___YmpnbU",
  "cU": "VoiceConnectionStatus.module__mediaIcon___YmpnbU",
  "jC": "VoiceConnectionStatus.module__popoutContainer___YmpnbU",
  "oO": "VoiceConnectionStatus.module__popoutBodyScroller___YmpnbU",
  "$V": "VoiceConnectionStatus.module__popoutBodyContent___YmpnbU",
  "hY": "VoiceConnectionStatus.module__popoutHeader___YmpnbU",
  "Gb": "VoiceConnectionStatus.module__popoutTitle___YmpnbU",
  "IZ": "VoiceConnectionStatus.module__popoutCloseButton___YmpnbU",
  "nO": "VoiceConnectionStatus.module__popoutStats___YmpnbU",
  "u$": "VoiceConnectionStatus.module__popoutStatsSection___YmpnbU",
  "yk": "VoiceConnectionStatus.module__popoutStatsSectionTitle___YmpnbU",
  "r6": "VoiceConnectionStatus.module__popoutStatsSectionRows___YmpnbU",
  "m1": "VoiceConnectionStatus.module__detailedStatsAccordion___YmpnbU",
  "G8": "VoiceConnectionStatus.module__detailedStatsButton___YmpnbU",
  "X6": "VoiceConnectionStatus.module__detailedStatsButtonText___YmpnbU",
  "VV": "VoiceConnectionStatus.module__detailedStatsCaret___YmpnbU",
  "hM": "VoiceConnectionStatus.module__detailedStatsContent___YmpnbU",
  "cl": "VoiceConnectionStatus.module__detailedStatsInner___YmpnbU",
  "gm": "VoiceConnectionStatus.module__popoutStatRow___YmpnbU",
  "Ub": "VoiceConnectionStatus.module__popoutStatLabel___YmpnbU",
  "Fz": "VoiceConnectionStatus.module__popoutStatValue___YmpnbU",
  "ep": "VoiceConnectionStatus.module__popoutStatTextValue___YmpnbU",
  "mp": "VoiceConnectionStatus.module__deviceBadge___YmpnbU",
  "Vs": "VoiceConnectionStatus.module__deviceBadgeText___YmpnbU",
  "hn": "VoiceConnectionStatus.module__endpointBadge___YmpnbU",
  "iu": "VoiceConnectionStatus.module__endpointBadgeText___YmpnbU",
  "_v": "VoiceConnectionStatus.module__chartContainer___YmpnbU",
  "nS": "VoiceConnectionStatus.module__chartSvg___YmpnbU",
  "$s": "VoiceConnectionStatus.module__gridLine___YmpnbU",
  "rK": "VoiceConnectionStatus.module__gridLineHorizontal___YmpnbU",
  "eB": "VoiceConnectionStatus.module__gridText___YmpnbU",
  "BC": "VoiceConnectionStatus.module__chartLine___YmpnbU",
  "Pi": "VoiceConnectionStatus.module__chartPoint___YmpnbU",
  "Hh": "VoiceConnectionStatus.module__textGreen___YmpnbU",
  "NV": "VoiceConnectionStatus.module__textBackgroundModifierHover___YmpnbU",
  "Bx": "VoiceConnectionStatus.module__iconSmall___YmpnbU",
  "Kt": "VoiceConnectionStatus.module__deviceIcon___YmpnbU",
  "hz": "VoiceConnectionStatus.module__lockIcon___YmpnbU",
  "Gy": "VoiceConnectionStatus.module__nsModalContent___YmpnbU",
  "uU": "VoiceConnectionStatus.module__nsOptions___YmpnbU",
};

module.exports = exports;
